export const QR_FORMATS = [
  {
    format: "PNG",
    value: "png",
  },
  {
    format: "SVG",
    value: "svg",
  },
  {
    format: "PDF",
    value: "pdf",
  },
  {
    format: "EPS",
    value: "eps",
  },
  {
    format: "JPG",
    value: "jpeg",
  },
];
